// fontFamily = 'oswald', fontSize = '13', fontWeight, children;
type AppButtonProps = {
  children: React.ReactNode;
  id?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  fontFamily?: 'oswald' | 'lato';
  fontWeight?: '400' | '500' | '600' | '700';
  fontSize?: '13' | '14' | '15' | '16' | '17' | '18' | '19' | '20' | '21' | '22' | '23' | '24';
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
    | 'transparent'
    | 'outline-primary'
    | 'outline-secondary'
    | 'outline-success'
    | 'outline-danger'
    | 'outline-warning'
    | 'outline-info'
    | 'outline-light'
    | 'outline-dark';
  className?: string;
  disabled?: boolean;
  dataTestId?: string;
  args?: any;
};

export const AppButton = ({
  children,
  variant = 'primary',
  type = 'button',
  onClick = () => {},
  fontFamily = 'oswald',
  fontSize = '13',
  fontWeight = '500',
  disabled = false,
  className = '',
  dataTestId = '',
  ...args
}: AppButtonProps) => {
  return (
    <button
      type={type}
      className={`btn btn-${variant} font-${fontFamily} font-${fontSize} font-${fontWeight} text-uppercase  ${
        disabled && 'disabled cursor-not-allowed'
      } ${className}`}
      onClick={(e) => onClick(e)}
      disabled={disabled}
      data-testid={dataTestId || 'testing-button'}
      {...args}
    >
      {children}
    </button>
  );
};

export default AppButton;
